import React from 'react';
import Table from './components/Table';
import UploadDrawer from './components/UploadDrawer';
import Controls from '@cp/pages/AgencyCapping/components/Controls';
import { AGENCY_CAPPING_CLICKSTREAM } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
function AgencyCapping() {
  const [isUploadDrawerOpen, setIsUploadDrawerOpen] = React.useState(false);
  return (
    <div className="px-9 ">
      <Controls
        openUploadDialog={() => {
          addClickstreamEvent(AGENCY_CAPPING_CLICKSTREAM.LH_CLICK_UPDATE_AGENCY_CAPPING_BUTTON);
          setIsUploadDrawerOpen(true);
        }}
      />
      <Table />
      <UploadDrawer isOpen={isUploadDrawerOpen} setClose={() => setIsUploadDrawerOpen(false)} />
    </div>
  );
}

export default AgencyCapping;
